import NormalSelect from "./common/Select/NormalSelect";
import SelectAsyncPaginate from "./common/Select/AsyncPaginateSelect";
import DatePickerDDMMYY from "./common/DatePickerDDMMYY";
import { logger } from "helper/logger";

export default function FiltersList({ filters, handleChange, selectedFilters, lockedFields = [] }) {
    // logger("filters changes", filters, selectedFilters)
    return (
        <div className="w-full flex flex-col space-y-5 mb-3 mt-5">
            <div className="flex flex-wrap pb-0">
                {
                    filters?.map((filter) => {
                        if (filter.isDateRange) {
                            const lockKey = filter.lockKey || filter.startKey;
                            return (
                                <div key={filter.id} className={`flex w-full flex-col gap-2 p-3 ${lockedFields?.indexOf(lockKey) >= 0 && "disabledContent"}`}>
                                    <span className="text-sm font-medium pl-0.5" style={{ color: "#3c4b64" }}>{filter.name}</span>
                                    <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
                                        <DatePickerDDMMYY
                                            label={filter.startLabel || "From"}
                                            value={selectedFilters[filter.startKey] || ""}
                                            onChange={(v) => handleChange(v, filter.startKey)}
                                            size="small"
                                            fullWidth
                                        />
                                        <DatePickerDDMMYY
                                            label={filter.endLabel || "To"}
                                            value={selectedFilters[filter.endKey] || ""}
                                            onChange={(v) => handleChange(v, filter.endKey)}
                                            minDate={selectedFilters[filter.startKey] || undefined}
                                            size="small"
                                            fullWidth
                                        />
                                    </div>
                                </div>
                            );
                        }
                        return (
                            <div key={filter.id} className={`flex w-full p-3 ${lockedFields?.indexOf(filter.value) >= 0 && "disabledContent"}`}>
                                {!filter.isAsync ?
                                    <NormalSelect
                                        key={filter.id}
                                        filter={filter}
                                        defaultValue={
                                            !filter.isMulti
                                                ? filter?.options?.find(option => option?.value == selectedFilters[filter?.value])
                                                : Array.isArray(selectedFilters[filter?.value])
                                                    ? selectedFilters[filter?.value].map(option2 => filter?.options?.find(option => option?.value == option2))
                                                    : null
                                        }
                                        handleChange={(e) => { handleChange(e.value, filter.value) }}
                                    /> :
                                    <SelectAsyncPaginate
                                        isSearchable={filter.isSearchable}
                                        key={filter.id}
                                        onChange={(e) => {
                                            handleChange(e.value, filter.value)
                                        }}
                                        getDefaultValue={() => {
                                            return filter?.getSelectedVal(selectedFilters[filter?.value])
                                        }}
                                        loadMore={filter.loadMore}
                                        filterName={filter.name}
                                        cacheUniqs={filter?.cacheUniqs}
                                        isMulti={filter?.isMulti}
                                    />}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}
